import { useEffect, useState } from 'react';
import { Tabs, Typography } from '@tempmee/react';
import { Column } from '~/commonComponents';
import { PendingReviewShiftsTab, TodayShiftsTab } from './components';
import { ActiveShiftTabEnum } from './enums';
import { useActiveShifts } from './hooks';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { EnforceOfficeDashboardV2 } from '~/constants/ff.posthog';
import {
  fireDashboardTodayShiftTabClicked,
  fireDashboardPendingReviewTabClicked,
} from '~/posthogs/events';

export const ActiveShift = () => {
  const { activeTab: defaultActiveTab, counters } = useActiveShifts();

  const [activeTab, setActiveTab] = useState<ActiveShiftTabEnum>(defaultActiveTab);

  const useOfficeDashboardV2 = useFeatureFlag(EnforceOfficeDashboardV2);

  useEffect(() => {
    setActiveTab(defaultActiveTab);
  }, [defaultActiveTab]);

  if (counters.todays === 0 && counters.reviews === 0) {
    return null;
  }

  return (
    <Column
      className="dashboard-active-shifts"
      paddingBlock={24}
      paddingInline={48}
      data-cy="active-shifts-container"
    >
      {!useOfficeDashboardV2 && (
        <Typography
          as="span"
          bold
          size="heading_3"
          textAlign="center"
          data-cy="active-shifts-title"
          style={{ marginInline: 'auto' }}
        >
          Active Shifts
        </Typography>
      )}

      <Tabs
        defaultValue={ActiveShiftTabEnum.Today}
        value={activeTab}
        onValueChange={(tab) => {
          const typedTab = tab as ActiveShiftTabEnum;
          if (typedTab === ActiveShiftTabEnum.Today) fireDashboardTodayShiftTabClicked();
          if (typedTab === ActiveShiftTabEnum.PendingReview) fireDashboardPendingReviewTabClicked();
          setActiveTab(typedTab);
        }}
        style={{ alignItems: 'start', gap: 16, marginTop: 24, width: '100%' }}
        data-cy="active-shifts-tabs"
      >
        <Tabs.List data-cy="active-shifts-tab-list">
          <Tabs.Tab
            value={ActiveShiftTabEnum.Today}
            label={counters.todays > 0 ? String(counters.todays) : undefined}
            data-cy="todays-shifts-tab"
          >
            Today&apos;s Professionals
          </Tabs.Tab>
          <Tabs.Tab
            value={ActiveShiftTabEnum.PendingReview}
            label={counters.reviews > 0 ? String(counters.reviews) : undefined}
            labelVariant="error"
            data-cy="pending-review-tab"
          >
            Pending Review
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel
          value={ActiveShiftTabEnum.Today}
          style={{ width: '100%' }}
          data-cy="active-shifts-tab-panel"
        >
          <TodayShiftsTab />
        </Tabs.Panel>
        <Tabs.Panel value={ActiveShiftTabEnum.PendingReview} style={{ width: '100%' }}>
          <PendingReviewShiftsTab />
        </Tabs.Panel>
      </Tabs>
    </Column>
  );
};
